import * as amplitude from '@amplitude/analytics-browser'
import { sessionReplayPlugin } from '@amplitude/plugin-session-replay-browser'
import { AMPLITUDE_API_KEY, APP_ENVIRONMENT } from 'env'
import { useEffect, useState } from 'react'

/**
 * Send an Amplitude tracking event.
 *
 * @param {String} event - The name of the event.
 * @param {Object} attributes - An object of any relevant event properties (optional).
 */
export const amplitudeEvent = (event, attributes = {}) => {
  amplitude.track(event, attributes)
}

const Amplitude = () => {
  const [activated, setActivated] = useState(false)

  useEffect(() => {
    if (!activated) {
      // enable session replay in development for testing purposes
      if (APP_ENVIRONMENT === 'development' || APP_ENVIRONMENT === 'dev') {
        // user input is hidden by default
        const sessionReplayTracking = sessionReplayPlugin({
          forceSessionTracking: true,
          sampleRate: 1,
          useWebWorker: true,
        })
        amplitude.add(sessionReplayTracking)
      }

      amplitude.init(AMPLITUDE_API_KEY, {
        // This allows Amplitude to send events asynchronously, including after a domain redirect.
        transport: 'beacon',
        // To make sure the event will be scheduled right away.
        flushIntervalMillis: 0,
        flushQueueSize: 1,
        // Prevent unneeded tracking.
        defaultTracking: {
          attribution: false,
          pageViews: false,
          sessions: false,
          formInteractions: false,
          fileDownloads: false,
        },
      })

      setActivated(true)
    }
  }, [activated])

  return null
}

export default Amplitude
